import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import CardContext from "../../context/card/CardContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import DataTable from "../common/DataTable";
// import { Orders } from "./../common/Orders";
// import Moment from "react-moment";
// import "moment-timezone";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";

const PatronSubscribeList = (props) => {
  const cardContext = useContext(CardContext);
  const {
    cards,
    isLoading,
    getCardsIndividualSubscriptions,
    modifySubscription,
  } = cardContext;

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Patron Subscription",
  });

  const history = useHistory();
  const [subscribeList, setSubscribeList] = useState([]);
  useEffect(() => {
    console.log("Cards::::", cards);
    if (cards) {
      setSubscribeList(getCardsIndividualSubscriptions(cards));
      console.log("Subsciptions::::", subscribeList);
      setTableAlert(
        "Search is successfully completed and matching records are displayed in the table"
      );
    }
    //eslint-disable-next-line
  }, [cards]);

  //setCurrentCard
  //   const selectCurrentOrder = async (orderId) => {
  //     console.log("Setting Order Details::::", orderId);
  //     try {
  //       const res = await getOrderDetails(orderId, token);
  //       console.log("Order Detail Res:", res);
  //       history.push("/order-detail");
  //     } catch (err) {
  //       clearAlerts();
  //       setAlert("Unexpected Error Occured", "danger");
  //     }
  //   };

  //   const getFormattedObject = (orders) => {
  //     if (!orders) return [];
  //     return orders.map((order) => {
  //       return {
  //         ...order,
  //         creationDate: moment
  //           .utc(order.creationDate)
  //           .tz("America/Chicago")
  //           .format("MM/DD/YYYY hh:mm A"),
  //         price: `$ ${(order.price / 100).toFixed(2)}`,
  //       };
  //     });
  //   };

  //   const searchOrders = async (criteria) => {
  //     console.log("###Criteria: ", criteria);
  //     const { searchBy, searchByValue, fromPeriod, toPeriod } = criteria;
  //     let searchCriteria = {};
  //     // searchCriteria = {
  //     //   filterType: searchBy === "" ? "all" : searchBy,
  //     // };
  //     if (searchBy !== "") {
  //       searchCriteria = {
  //         filterType: searchBy,
  //       };
  //       if (searchByValue !== "") {
  //         searchCriteria = {
  //           ...searchCriteria,
  //           filterValue: searchByValue,
  //         };
  //       } else {
  //         searchCriteria = {
  //           ...searchCriteria,
  //           filterValue: searchBy,
  //         };
  //       }
  //     }

  //     setSearchCriteria((prevCriteria) => ({
  //       ...prevCriteria,
  //       ...searchCriteria,
  //     }));

  //     if (criteria.fromPeriod > criteria.toPeriod) {
  //       clearAlerts();
  //       setAlert("From Date can not be later than To Date", "warning");
  //       return;
  //     } else if (criteria.fromPeriod !== criteria.toPeriod) {
  //       searchCriteria = {
  //         ...searchCriteria,
  //         fromDate: moment(fromPeriod).format("DD-MM-YYYY"),
  //         toDate: moment(toPeriod).format("DD-MM-YYYY"),
  //       };
  //     }
  //     try {
  //       console.log("$$Criteria: ", searchCriteria);
  //       const res = await loadOrders(searchCriteria, token);
  //       console.log("$$RES: ", res);
  //       if (res.msgCode) {
  //         const msg = getConfigValueByCode(
  //           "generalConfig",
  //           "RESPONSE_MSG",
  //           res.msgCode
  //         );
  //         clearAlerts();
  //         setAlert(msg, "warning");
  //       }
  //       if (res.length === 0) {
  //         clearAlerts();
  //         setAlert("No matching records found", "warning");
  //       }
  //     } catch (err) {
  //       console.log("$ERR:", err);
  //       // const msg = getConfigValueByCode(
  //       //   "generalConfig",
  //       //   "RESPONSE_MSG",
  //       //   500
  //       // );
  //       if (err.msgCode) {
  //         const msg = getConfigValueByCode(
  //           "generalConfig",
  //           "RESPONSE_MSG",
  //           err.msgCode
  //         );
  //         clearAlerts();
  //         setAlert(msg, "warning");
  //       }

  //       clearAlerts();
  //       setAlert("Unexpected Error Occured", "danger");
  //     }
  //   };
  const { hasTokenExpired } = useTokenCheck();
  const addSubscription = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    modifySubscription(null);
    history.push("/single-subscribe");
  };
  const columnDefs = [
    {
      Header: "Serial #",
      accessor: "serialNumber",
    },
    {
      Header: "Contract Type",
      accessor: "profileName",
    },
    {
      Header: "Max Recharges",
      accessor: "maxNumberOfRecharges",
    },
    {
      Header: "Threshold Amount",
      accessor: "threshold",
    },
    {
      Header: "Recharge Amount",
      accessor: "rechargeValue",
    },
  ];

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {isLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="patronPage__pageTitle">
          METRO Q CARD® SUBSCRIPTIONS
        </h1>
        <div aria-live="polite" style={{ color: "transparent", height: "1px" }}>
          {tableAlert}
        </div>
        <div className="patronPage__content">
          {subscribeList.length > 0 ? (
            <div className="patronPage__tableListing">
              <DataTable
                data={subscribeList}
                columnDefs={columnDefs}
                turnOffFilter={true}
              />
            </div>
          ) : (
            "There are no subscription available. Click on Add Subscription button to subscribe."
          )}
        </div>
        <div id="pageAction" className="patronHome__actionPanel">
          <button
            aria-label="Add Subscription "
            className="btn btn-primary patronHome__actionPanel__button"
            onClick={addSubscription}
            id="btnAddSubscription"
            name="addSubscription"
          >
            Add Subscription
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default PatronSubscribeList;
